import React from 'react';
import {
  Card,
  CardHeader,
  CardBody
} from "@heroui/react";

interface StatItem {
  value: number;
  label: string;
  bgColor?: string;
  textColor?: string;
  valueColor?: string;
}

interface StatsCardProps {
  title: string;
  stats: StatItem[];
  className?: string;
  columns?: 1 | 2 | 3 | 4;
}

/**
 * StatsCard - A reusable component for displaying statistics in a card
 */
export default function StatsCard({
  title,
  stats,
  className = "",
  columns = 2
}: StatsCardProps) {
  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>
      <CardHeader className="pb-0 px-6">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </CardHeader>
      <CardBody className="p-6">
        <div className={`grid grid-cols-${columns} gap-4`}>
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className={`${stat.bgColor || 'bg-blue-50'} p-4 rounded-lg text-center`}
            >
              <span className={`block text-3xl font-bold ${stat.valueColor || 'text-blue-600'}`}>
                {stat.value}
              </span>
              <span className={`block text-sm ${stat.textColor || 'text-blue-700'} mt-1`}>
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}